import React from 'react';
import { motion } from 'framer-motion';
import { Clock, AlertCircle } from 'lucide-react';
import { OfferCard } from './OfferCard';
import { CountdownTimer } from './CountdownTimer';
export const UrgencyPricing = () => {
  return <section className="py-12 md:py-20 bg-navy-800 text-white border-y-4 border-vbred" data-id="element-213" data-mp="rni99smhrzsx">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-214" data-mp="votw5qdze6xf">
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="inline-flex items-center gap-2 bg-vbred/20 text-vbred px-3 md:px-4 py-1.5 md:py-2 rounded-full text-sm md:text-base font-bold uppercase tracking-wider mb-6 md:mb-8 border border-vbred/30" data-id="element-215" data-mp="hxylc8jx9fr7">
          <Clock className="w-4 h-4 md:w-5 md:h-5 animate-pulse" data-id="element-216" data-mp="3v73cz0q3lu5z" />
          Launch Price Ends Soon
        </motion.div>

        <h2 className="text-xl md:text-3xl font-bold mb-4" data-id="element-217" data-mp="1ydeedtae9b5c">
          After this — the price increases permanently and will not come back
          down.
        </h2>

        {/* Compact urgency countdown */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="inline-flex flex-col items-center gap-3 bg-navy-900/60 border border-vbred/30 rounded-2xl px-5 md:px-8 py-4 md:py-5 mb-6 md:mb-8 shadow-xl" data-id="element-218" data-mp="28bc2mgs977xy">
          <p className="text-[11px] md:text-xs font-bold uppercase tracking-[0.2em] text-vbred" data-id="element-219" data-mp="1pczrwqlp1q09">
            ⚡ This Price Disappears In
          </p>
          <CountdownTimer data-id="element-220" data-mp="1kjwxkg93ecj0" />
        </motion.div>

        <div className="flex items-center justify-center gap-2 text-vbgold font-medium mb-8 md:mb-12 text-sm md:text-base" data-id="element-221" data-mp="wvnf9ob386wm">
          <AlertCircle className="w-4 h-4 md:w-5 md:h-5 animate-pulse" data-id="element-222" data-mp="rwsyst0leufo" />
          <p className="font-bold" data-id="element-223" data-mp="2s0dcyhkvy6q9">
            Only A Few Launch Spots Left — Selling Out Fast
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-224" data-mp="2wx3s92ov8yam">
          <OfferCard data-id="element-225" data-mp="290pr26ijwerf" />
        </motion.div>
      </div>
    </section>;
};